import { Component, OnInit, Input } from '@angular/core';
import { Benefit } from '@fgb/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'fgb-benefit-info-modal',
  templateUrl: './benefit-info-modal.component.html',
  styleUrls: ['./benefit-info-modal.component.scss']
})
export class BenefitInfoModalComponent implements OnInit {

  @Input() benefit: Benefit;

  constructor(private activeModal: NgbActiveModal) { }

  ngOnInit() {
  }

  closeModal(): void {
    this.activeModal.close();
  }

}
